/** @format */
import isPropValid from '@emotion/is-prop-valid';
import {
    Button,
    ButtonVariant,
} from '@mpb-com/feather/components/atoms/button';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import { MarketContext } from '@toucan/client/global/market';
import { WrappedLink } from '@toucan/client/global/nextjs';

import { LinkVariant } from '@toucan/client/shared/components/link';

import { styles } from './basket-empty-message.styles';

export type BasketEmptyMessageProps = {
    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
};

const StyledBasketEmptyMessage = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const BasketEmptyMessage: FunctionComponent<BasketEmptyMessageProps> = ({
    ...otherProps
}: BasketEmptyMessageProps) => {
    const { t } = useTranslation();

    const { activeMarket } = useContext(MarketContext);
    const shopSlug = t('shop', {
        ns: 'urls',
    });

    return (
        <StyledBasketEmptyMessage {...otherProps}>
            <div className="basket-empty-message">
                <p>
                    {t(
                        "You don't have anything in your basket. Let's fix that."
                    )}
                </p>
                <WrappedLink
                    variant={LinkVariant.CUSTOM}
                    href={`cms/landing-page?slug=${shopSlug}`}
                    as={`/${activeMarket.slug}/${shopSlug}`}
                    passHref={true}
                >
                    <Button
                        variant={ButtonVariant.SECONDARY}
                        className="basket-empty-message-cta"
                        data-testid="basket-empty-message-cta"
                    >
                        {t('Explore camera gear')}
                    </Button>
                </WrappedLink>
            </div>
        </StyledBasketEmptyMessage>
    );
};
